import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const skipUrls = ['http://app.heimdaltest.no:4200/assets/icons.svg', 'https://app.apexapp.io/assets/icons.svg'];

@Injectable()
export class NotificationInterceptor implements HttpInterceptor {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const url = new URL(location.href);

    if (skipUrls.includes(req.url)) {
      return next.handle(req);
    }

    const notification = url?.searchParams?.get('doNotSendNotifications');

    if (!notification) {
      return next.handle(req);
    }

    const clonedRequest = req.clone({
      headers: req.headers.set('doNotSendNotifications', notification),
    });

    return next.handle(clonedRequest);
  }
}
